module.exports = __webpack_public_path__ + "img/LTS_SAIGA_2.5d1cefa5.gif";